import { useEffect, useState } from "react";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "../../components/ui/popover";
import { Button } from "../../components/ui/button";
import {
	Command,
	CommandEmpty,
	CommandGroup,
	CommandInput,
	CommandItem,
	CommandList,
} from "../../components/ui/command";
import { Checkbox } from "../../components/ui/checkbox";
import { Calendar, Check, ChevronDown } from "lucide-react";

interface TypesMultiselect {
	title: string;
	IconLucide: any;
	Searchable?: boolean;
	data: any;
	onSelectChange?: (selected: string[]) => void;
	CurrentSelected: any
}

const MultiSelect: React.FC<TypesMultiselect> = ({
	title,
	IconLucide,
	Searchable,
	data,
	onSelectChange,
	CurrentSelected,
}) => {
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState<string[]>([]);

	useEffect(() => {
		if (CurrentSelected) {
			setSelected(CurrentSelected)
		}
	}, [])


	const toggleOption = (value: string) => {
		setSelected((prev) => {
			const newSelected = prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value];
			if (onSelectChange) {
				onSelectChange(newSelected); // Chamando a função de callback
			}
			return newSelected;
		});
	};


	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild className="w-[180px] rounded-[30px]">
				<Button
					variant="outline"
					role="combobox"
					style={{ fontWeight: 400 }}
					className="w-[200px]  flex items-start justify-between gap-2"
				>
					<div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
						<IconLucide className="w-4 h-4" color="#000E4B" />
						{selected.length > 0 ? `${selected.length} selecionado(s)` : title}
					</div>
					<ChevronDown className="w-3 h-3" color="#000E4B" />
				</Button>

			</PopoverTrigger>

			<PopoverContent className="w-[200px] p-0 bg-white pointer-events-auto">
							
				<Command style={{pointerEvents: 'all'}}>
					{Searchable &&
					<>
					
					<CommandInput placeholder="Pesquisar etiquetas"/>
					
					</>
					}
					<CommandList>

						<CommandEmpty>No results found.</CommandEmpty>

						{data.map((option: any) => (
							<CommandItem
								style={{ color: "#3D4259" }}
								key={option.value}
								onSelect={() => toggleOption(option.value)}
							
							>
								<Checkbox
									style={{ color: "#3D4259" }}
									checked={selected.includes(option.value)}
									onCheckedChange={() => toggleOption(option.value)}
									className="mr-2"
								/>
								{option.label}
							</CommandItem>
						))}
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	);
};

export default MultiSelect;
